export default __webpack_public_path__ + "static/media/vector.00e6df9f.svg";